import React from "react";
import "./SmsAnalytics.css";

const SmsAnalytics = () => {
  return (
    <div className="sms-analytics">
      <div className="analytics-header">
        <h1>SMS Analytics</h1>
      </div>
      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon total">
            <span className="material-icons">sms</span>
          </div>
          <div className="card-content">
            <h3>Total SMS Sent</h3>
            <p className="metric-value">28,542</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon delivered">
            <span className="material-icons">check_circle</span>
          </div>
          <div className="card-content">
            <h3>Delivered</h3>
            <p className="metric-value">27,840</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon failed">
            <span className="material-icons">error</span>
          </div>
          <div className="card-content">
            <h3>Failed</h3>
            <p className="metric-value">702</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon rate">
            <span className="material-icons">percent</span>
          </div>
          <div className="card-content">
            <h3>Delivery Rate</h3>
            <p className="metric-value">97.5%</p>
          </div>
        </div>
      </div>
      <div className="info-message">
        <span className="material-icons">info</span>
        <p>SMS analytics dashboard coming soon with detailed delivery reports and trends</p>
      </div>
    </div>
  );
};

export default SmsAnalytics;
